import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SideNavbar.module.css";

const SideNavbar = () => {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  return (
    <>
      <button
        id="basic-button"
        className={styles.sideBurgerNav}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MenuRoundedIcon
          fontSize={"large"}
        />
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => navigate("/clients")}>Details</MenuItem>
        <MenuItem onClick={() => navigate("/clients/notes")}>Notes</MenuItem>
        <MenuItem onClick={() => navigate("/clients/surveys")}>Surveys</MenuItem>
        <MenuItem onClick={() => navigate("/clients/manage-program")}>Manage Program</MenuItem>
      </Menu>
    </>
  );
};

export default SideNavbar;